import type { ScholarshipCategory } from "@mhj/shared/types";

export const REQUIRED_DOCS: Record<ScholarshipCategory, string[]> = {
  jamb: [
    "o_level_result",
    "passport",
    "indigene_certificate",
    "birth_certificate",
  ],
  undergraduate: [
    "admission_letter",
    "student_id",
    "passport",
    "academic_transcript",
    "school_fees_receipt",
    "birth_certificate",
    "indigene_certificate",
  ],
  postgraduate: [
    "admission_letter",
    "degree_certificate",
    "academic_transcript",
    "school_fees_receipt",
    "birth_certificate",
    "passport",
    "indigene_certificate",
  ],
  others: [
    "admission_letter",
    "student_id",
    "passport",
    "academic_transcript",
    "school_fees_receipt",
    "birth_certificate",
    "indigene_certificate",
  ],
};

export const CATEGORY_LABELS: Record<ScholarshipCategory, string> = {
  jamb: "JAMB",
  undergraduate: "Undergraduate",
  postgraduate: "Postgraduate",
  others: "Others",
};
